// extracted by mini-css-extract-plugin
export default {"modalContainer":"ChangeUserIdModal_modalContainer__uN6OM","modalContent":"ChangeUserIdModal_modalContent__lC+E7","modalTitle":"ChangeUserIdModal_modalTitle__wU0Vh"};